import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Access } from '../shared/access.model';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE } from '../../../../shared/session/index';
import { AccessService } from '../shared/access.service';

@Component({
	//moduleId: module.id,
	selector: 'app-access-view',
	templateUrl: 'access-view.component.html'
})
export class AccessViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  access: Access;
  msgErrorGet: string;

  constructor(private loaderService: LoaderService,
    private accessService: AccessService,
    private notificationService: NotificationService,
    private utilityService: UtilityService) { }

  ngOnInit() {
    this.access = new Access( 0,1, "", "", "", "", "", false,"Activo","","","","", "",1);
    this.msgErrorGet = 'Error al obtener datos';
    this.obtenerAccess(this.data.access.ID);
  }

  private obtenerAccess(id: number): void {
    this.loaderService.show();
    this.accessService.obtenerAccess(id)
    .subscribe(res => {
      this.access = res;
      this.utilityService.setAuditoria(this.access);
    },
    error => {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }
}
